<template>
  <div class="cs-purchase-provider">
    <button
      class="cs-purchase-provider-checkout-button"
      :disabled="loading"
      @click="checkout"
    >
      {{ checkoutButtonText }}
    </button>
    <p class="cs-purchase-provider-info">
      Quando clicar no meio de pagamento você será direcionado para o site pagador finalizar a compra
    </p>
  </div>
</template>

<script>
import swal from 'sweetalert'
import { mapGetters, mapState } from 'vuex'

const INITIAL_CHECKOUT_BUTTON_TEXT = 'Finalizar compra com a Yapay',
  FINISHING_CHECKOUT_BUTTON_TEXT = 'Finalizando compra...'

let YapayComponent = {
  name: 'Yapay',

  props: {
    needSelectShipping: Boolean
  },

  data() {
    return {
      checkoutButtonText: INITIAL_CHECKOUT_BUTTON_TEXT
    }
  },

  computed: {
    ...mapGetters('purchase', ['getCheckoutUrlByProvider']),
    ...mapState('cart', ['cart', 'loading']),
    ...mapState('shipping', ['shipping']),

    checkoutUrl() {
      return this.getCheckoutUrlByProvider('yapay')
    }
  },

  methods: {
    async checkout() {
      if(this.needSelectShipping) {
        swal(
          'Ops!',
          'Você precisa calcular o frete e escolher uma opção de envio!',
          'error'
        )
        return
      }

      this.checkoutButtonText = FINISHING_CHECKOUT_BUTTON_TEXT
      this.$store.dispatch('cart/setLoading', true)

      try {
        await this.$store.dispatch('purchase/checkout', {
          cartId: this.cart.id,
          provider: 'yapay',
          shipping: {
            shippingName: this.shipping.currentService.shippingName,
            destinationPostalCode: this.shipping.address.destination.postalCode,
            service: this.shipping.currentService.name
          }
        })
      } catch(e) {
        swal('Ops!', 'Não foi possível finalizar sua compra, tente novamente.', 'error')
        this.checkoutButtonText = INITIAL_CHECKOUT_BUTTON_TEXT
        this.$store.dispatch('cart/setLoading', false)
      }
    }
  },

  watch: {
    checkoutUrl(newCheckoutUrl, _oldCheckoutUrl) {
      window.location.assign(newCheckoutUrl)
    }
  }
}

export default YapayComponent
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_mixins.scss';

.cs-purchase-provider {
  @include tablet-landscape-up { text-align: right; }

  .cs-purchase-provider-checkout-button {
    @include phone-only { width: 100%; margin-top: 2%; }
    @include tablet-portrait-up { width: 350px; }
    border-radius: 4px;
    height: 50px;
    font-size: 18px;
    border-style: unset;
    color: #fff;
    background-color: #0266cc;
    outline: none;
    cursor: pointer;
  }

  .cs-purchase-provider-checkout {
    color: #2C3E50;
    font-size: 12px;
    text-align: right;
  }
}
</style>
